export const fsExcludeClass = 'fs-exclude'

export const excludedIdentifiers = [
  'levelname',
  'accountnumber',
  'accountname',
  'shortname',
  'longname',
  'longnumber',
  'shortnumber',
  'phonenumber',
  'phone',
  'primaryphone',
  'firstname',
  'lastname',
  'clientname',
  'client',
  'clients',
  'assignedClients',
  'dynamic_filter_clients',
  'email',
  'useremail'
]

export function isExcludedIdentifier (identifier) {
  return excludedIdentifiers.includes((identifier ?? '').toLowerCase())
}

export function isExcludedAccessor (accessor) {
  return excludedIdentifiers.some(id => (accessor ?? '').toLowerCase().includes(id?.toLowerCase()))
}
